import React from 'react'

function close(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 15 15">
      <path fill={props.isDarkMode ? "#CBCED1" : "#54545699"} d="M14.609,12.617A1.46,1.46,0,0,1,15,13.633,1.335,1.335,0,0,1,13.633,15a1.46,1.46,0,0,1-1.016-.391L7.5,9.492,2.383,14.609a1.416,1.416,0,0,1-1.953,0A1.265,1.265,0,0,1,0,13.633a1.389,1.389,0,0,1,.43-1.016L5.508,7.5.43,2.383A1.389,1.389,0,0,1,0,1.367,1.265,1.265,0,0,1,.43.391a1.416,1.416,0,0,1,1.953,0L7.5,5.508,12.617.391A1.46,1.46,0,0,1,13.633,0,1.335,1.335,0,0,1,15,1.367a1.46,1.46,0,0,1-.391,1.016L9.492,7.5Z"/>
      </svg>
  )
}

export default close